/**
 * GoJS diagram layout: SideTreeLayout (assistant-aware tree) and helpers.
 * Requires window.go.
 */
const go = typeof window !== 'undefined' ? window.go : null;

function isAssistant(n) {
  if (n === null) return false;
  return n.data.isAssistant;
}

function changeLabel(node, label) {
  if (!window.myDiagram) return;
  window.myDiagram.startTransaction('changeLabel');
  const data = node.data;
  window.myDiagram.model.setDataProperty(data, 'label', 'test');
  window.myDiagram.model.setDataProperty(data, 'label', label);
  window.myDiagram.commitTransaction('changeLabel');
}

class SideTreeLayout extends go.TreeLayout {
  makeNetwork(coll) {
    const net = super.makeNetwork(coll);
    const vertexcoll = new go.Set(/*go.TreeVertex*/);
    vertexcoll.addAll(net.vertexes);
    for (const it = vertexcoll.iterator; it.next();) {
      const parent = it.value;
      let acount = 0;
      const ait = parent.destinationVertexes;
      while (ait.next()) {
        if (isAssistant(ait.value.node)) acount++;
      }
      if (acount > 0) {
        const asstedges = new go.Set(/*go.TreeEdge*/);
        const childedges = new go.Set(/*go.TreeEdge*/);
        let eit = parent.destinationEdges;
        while (eit.next()) {
          const e = eit.value;
          if (isAssistant(e.toVertex.node)) {
            asstedges.add(e);
          } else {
            childedges.add(e);
          }
        }
        eit = asstedges.iterator;
        while (eit.next()) { parent.deleteDestinationEdge(eit.value); }
        eit = childedges.iterator;
        while (eit.next()) { parent.deleteDestinationEdge(eit.value); }
        if (acount % 2 == 1) {
          const dummy = net.createVertex();
          net.addVertex(dummy);
          net.linkVertexes(parent, dummy, asstedges.first().link);
        }
        eit = asstedges.iterator;
        while (eit.next()) {
          parent.addDestinationEdge(eit.value);
        }
        const subst = net.createVertex();
        net.addVertex(subst);
        eit = childedges.iterator;
        while (eit.next()) {
          const ce = eit.value;
          ce.fromVertex = subst;
          subst.addDestinationEdge(ce);
        }
        net.linkVertexes(parent, subst, null);
      }
    }
    return net;
  }

  assignTreeVertexValues(v) {
    let any = false;
    const children = v.children;
    for (let i = 0; i < children.length; i++) {
      if (isAssistant(children[i].node)) {
        any = true;
        break;
      }
    }
    if (any) {
      v.alignment = go.TreeLayout.AlignmentBus;
      v.nodeSpacing = 50;
    } else if (v.node == null && v.childrenCount > 0) {
      v.layerSpacing = 0;
    }
  }

  commitLinks() {
    super.commitLinks();
    const eit = this.network.edges.iterator;
    while (eit.next()) {
      const e = eit.value;
      if (e.link == null) continue;
      const r = e.link;
      const subst = e.fromVertex;
      if (subst.node == null && r.routing == go.Link.Orthogonal) {
        try {
          r.updateRoute();
          r.startRoute();
          const p2 = r.getPoint(2).copy();
          const p3 = r.getPoint(3).copy();
          const p5 = r.getPoint(r.pointsCount - 1);
          let dist = 10;
          if (subst.angle == 270 || subst.angle == 180) dist = -20;
          if (subst.angle == 90 || subst.angle == 270) {
            p2.y = p5.y - dist;
            p3.y = p5.y - dist;
          } else {
            p2.x = p5.x - dist;
            p3.x = p5.x - dist;
          }
          r.setPoint(2, p2);
          r.setPoint(3, p3);
          r.commitRoute();
        } catch (err) {}
      }
    }
  }
}

export { SideTreeLayout, isAssistant, changeLabel };
